import { BaseHandler } from "../../../infrastructure/base-handlers";
import { AddCustomFiltersCommand } from "../../filter/custom-filters/add-custom-filters/request";
import { addBusyHistoryItem, removeBusyHistoryItem } from "../handle-busy/actions";
import { addErrorHistoryItem } from "../handle-error/actions";
import { InjectAsyncHistoryItemsPayload } from "./request";
import { validateAddAsyncCommand } from "./validate-add-async-items-command";

export class InjectAsyncHistoryItemsHandler extends BaseHandler {
  async handle(payload: InjectAsyncHistoryItemsPayload) {
    this.store.dispatch(addBusyHistoryItem(payload.entityId));
    try {
      const items = await payload.asyncDataProvider();
      validateAddAsyncCommand(payload, items);
      this.api.broker.send(this.api.broker.events.activityHistory.addHistoryItemsRequest, {
        entityId: payload.entityId,
        entityDescription: payload.entityDescription,
        items,
        componentFactory: payload.componentFactory,
        searchPredicate: payload.searchPredicate,
        filters: payload.filters,
        historyDataImporterRules: payload.historyDataImporterRules,
      });
    } catch (e) {
      console.error(e.message);
      this.store.dispatch(
        addErrorHistoryItem({
          entityId: payload.entityId,
          message: payload.errorMessage || e.message,
          entityDescription: payload.entityDescription,
        }),
      );
    } finally {
      this.store.dispatch(removeBusyHistoryItem(payload.entityId));
    }
  }
}
